import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import * as React from 'react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { MessageBarButton } from 'office-ui-fabric-react/lib/Button';
import strings from 'owa-strings/owa-options-strings';
import store from '../store/store';
import DomainEnrollOptionFull from './DomainEnrollOptionFull';
import { removeDomain } from '../actions/removeDomain';
import { manageDomainClick } from '../actions/manageDomainClick';
import { createEmail } from '../actions/createEmail';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { getPremiumUser } from '../actions/getPremiumUser';
import { validateDomain } from '../actions/validateDomain';
import { traceDomainUIStatue } from '../utils/domainOptionTracer';
import addHours from 'date-fns/add_hours';
var styles = require('./DomainOptionFull.scss');
var DomainOptionFull = /** @class */ (function (_super) {
    tslib_1.__extends(DomainOptionFull, _super);
    function DomainOptionFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DomainOptionFull.prototype.componentDidMount = function () {
        getPremiumUser();
        validateDomain();
    };
    DomainOptionFull.prototype.render = function () {
        if (store.isDomainCreated) {
            var messageType;
            var messageText;
            var isShowCreateEmailButton = false;
            var isShowWarningButton = false;
            var isShowRemoveDomainButton = false;
            var today = new Date();
            var isDomainCreated24HoursAgo = false;
            if (store.domainPurchaseDate && addHours(store.domainPurchaseDate, 24) < today) {
                isDomainCreated24HoursAgo = true;
            }
            if (store.isValid) {
                if (store.isProsumerConsumerMailbox) {
                    messageType = MessageBarType.success;
                    messageText = strings.options_premiumSubOption_SuccessText;
                    isShowRemoveDomainButton = true;
                }
                else {
                    messageType = MessageBarType.warning;
                    messageText = strings.options_premiumSubOption_CreateEmailText;
                    isShowWarningButton = true;
                    isShowCreateEmailButton = true;
                }
            }
            else {
                if (isDomainCreated24HoursAgo) {
                    messageType = MessageBarType.error;
                    messageText = strings.options_premiumSubOption_ErrorText;
                }
                else {
                    messageType = MessageBarType.info;
                    messageText = strings.options_premiumSubOption_WarningText;
                }
                isShowWarningButton = true;
            }
            traceDomainUIStatue(store.isProsumerConsumerMailbox, messageType.toString());
            messageText = messageText.replace('{0}', store.domainName);
            return (React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement("div", { className: styles.domain_text_container }, strings.options_premium_PersonalEmail_description1),
                    React.createElement("div", { className: styles.domain_btn_container },
                        React.createElement(PrimaryButton, { text: strings.options_premium_buttonText, "data-is-focusable": true, disabled: false, onClick: manageDomainClick }))),
                React.createElement("div", { className: styles.messagebar },
                    store.isValidatingDomain && (React.createElement("div", { className: styles.waitingSpin },
                        React.createElement(Spinner, { size: SpinnerSize.medium, className: styles.spinner }))),
                    !store.isValidatingDomain && (React.createElement(MessageBar, { messageBarType: messageType, isMultiline: true, actions: React.createElement("div", null,
                            store.isRemovingDomain && (React.createElement(Spinner, { size: SpinnerSize.medium, className: styles.spinner })),
                            isShowCreateEmailButton && (React.createElement(MessageBarButton, { onClick: createEmail, disabled: store.isRemovingDomain }, strings.options_premiumSubOption_CreateEmailButton)),
                            isShowWarningButton && (React.createElement(MessageBarButton, { onClick: removeDomain, disabled: store.isRemovingDomain }, strings.options_premiumSubOption_WarningButton)),
                            isShowRemoveDomainButton && (React.createElement(MessageBarButton, { onClick: removeDomain, disabled: store.isRemovingDomain }, strings.options_premiumSubOption_RemoveDomainButton))) },
                        messageText,
                        React.createElement("a", { href: "https://go.microsoft.com/fwlink/?linkid=871933", target: "_blank" }, strings.options_premium_AdvancedSecurityContent_LearnMore))))));
        }
        else {
            return React.createElement(DomainEnrollOptionFull, null);
        }
    };
    DomainOptionFull = tslib_1.__decorate([
        observer
    ], DomainOptionFull);
    return DomainOptionFull;
}(React.Component));
export default DomainOptionFull;
//# sourceMappingURL=DomainOptionFull.js.map